import axios from 'axios'
import { jwtService } from '../helpers/jwt'

const { API_URL } = require('../config.json')

axios.defaults.timeout = 400000
axios.defaults.withCredentials = true
axios.defaults.baseURL = API_URL
axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.refreshToken = () => {
	axios.defaults.headers.common['Authorization'] = localStorage.getItem('token') ? 'Bearer ' + localStorage.getItem('token') : (localStorage.getItem('tempToken') ? 'Bearer ' + localStorage.getItem('tempToken') : '')
}

axios.interceptors.request.use(config => {
    // Verifica se o método da requisição é POST
	const fingerprint = localStorage.getItem('fingerprint')
	const fingerprintComponents = localStorage.getItem('fingerprintComponents')
	const fingerprintConfidence = localStorage.getItem('fingerprintConfidence')

	// Adiciona o fingerprint em todos os requests
	config.data = {
		...config.data,
		fingerprint,
		fingerprintComponents,
		fingerprintConfidence,
	}
    return config
}, error => {
    // Lida com erros na configuração da requisição
    return Promise.reject(error)
})

axios.interceptors.response.use(response => {
	// Se alguma resposta contiver "token", renova o token local automaticamente
    if (response.data && response.data.token) {
		localStorage.setItem('token', response.data.token)
        axios.refreshToken()
	}

	return response
}, error => {
	if (!error.response) {
		// Handle API Offline Error
	}
	else if (error.response.status === 401) {
		window.location.href = '/'
	}
	return error
})

axios.generateTempToken = async () => {
	const now = parseInt(new Date().getTime() / 1000)

	const tempToken = localStorage.getItem('tempToken')

	let tempTokenData

	if (tempToken)
		tempTokenData = jwtService.decode(tempToken)

	if (!tempToken || now > tempTokenData.payload.exp) {
		const response = await axios.get('/user/temptoken')

		if (!response)
			return false

		localStorage.setItem('tempToken', response.data.token)
	}

	axios.refreshToken()
}

axios.refreshToken()

export default axios